import { DesignPreview } from "containers/admin/clients/touchpoint/components/design-preview/design-preview";
import { SkeletonLoader } from "components/modals/create-parent-touchpoint-modal/components/skeleton-loader";

import { VersionPreviewData } from "components/modals/compare-versions-modal/hooks/use-compare-versions";
import { removeUserIdFromString } from "utilities/touchpoint";

import { Box } from "ui/box";
import { Typography } from "ui/typography";

import Icons from "assets";

import {
  COLUMN_SX,
  LOADING_OVERLAY_SX,
  PREVIEW_SX,
  EMAIL_HEADER_SX,
  SUBJECT_LINE_SX,
  PREHEADER_SX,
  ERROR_SX,
  ERROR_CONTENT_SX,
  ERROR_MESSAGE_SX,
  ERROR_HEADING_SX,
  REWRITER_CHANGES_SX,
  REWRITER_CHANGES_LABEL_SX,
  REWRITER_CHANGES_TEXT_SX,
} from "components/modals/compare-versions-modal/components/version-compare-column.styles";

interface VersionCompareColumnProps {
  isLoading: boolean;
  hasVersion: boolean;
  showError: boolean;
  version?: VersionPreviewData;
  isEmailType: boolean;
  hideSubjectAndPreheader?: boolean;
}

const VersionCompareColumn = ({
  isLoading,
  hasVersion,
  showError,
  version,
  isEmailType,
  hideSubjectAndPreheader = false,
}: VersionCompareColumnProps) => {
  return (
    <Box sx={COLUMN_SX}>
      {isLoading && (
        <Box sx={LOADING_OVERLAY_SX}>
          <SkeletonLoader />
        </Box>
      )}
      {hasVersion && (
        <Box sx={PREVIEW_SX}>
          {isEmailType && !hideSubjectAndPreheader && (
            <Box sx={EMAIL_HEADER_SX}>
              <Typography variant="body2" component="p" sx={SUBJECT_LINE_SX}>
                {version?.subjectLine || "[Email subject line]"}
              </Typography>
              <Typography variant="caption" component="p" sx={PREHEADER_SX}>
                {version?.preheader || "[Email preheader text...]"}
              </Typography>
            </Box>
          )}
          <DesignPreview
            htmlContent={removeUserIdFromString(version!.html!)}
            htmlJSON={version!.beeJson!}
            mobileView
          />
        </Box>
      )}
      {hasVersion && version?.rewriterChanges && (
        <Box sx={REWRITER_CHANGES_SX}>
          <Typography variant="body2" sx={REWRITER_CHANGES_LABEL_SX}>
            Rewriter changes:
          </Typography>
          <Typography variant="body2" sx={REWRITER_CHANGES_TEXT_SX}>
            {version.rewriterChanges}
          </Typography>
        </Box>
      )}
      {showError && (
        <Box sx={ERROR_SX}>
          <Box sx={ERROR_CONTENT_SX}>
            <Box sx={ERROR_MESSAGE_SX}>
              <Icons.ExclamationCircle />
              <Typography component="h3" variant="inherit" sx={ERROR_HEADING_SX}>
                Failed to load version
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default VersionCompareColumn;
